import React from 'react';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import { curveCardinal } from 'd3-shape';
import {
	AudioWaveFill,
	AudioWaveFillOpacity,
	AudioWaveHeight,
	AudioWaveMargin,
	AudioWaveStroke,
	AudioWaveStrokeOpacity,
	AudioWaveWidth,
} from '../../Common/Common.params';

const cardinal = curveCardinal.tension(0.2);

const Amplitude = ({ data }: { data: Array<{ v: number }> }) => {
	try {
		return (
			<ResponsiveContainer width="100%" height="100%">
				<AreaChart
					width={AudioWaveWidth}
					height={AudioWaveHeight}
					data={data}
					margin={AudioWaveMargin}
				>
					<Area
						isAnimationActive={false}
						type={cardinal}
						dataKey="v"
						stroke={AudioWaveStroke}
						fill={AudioWaveFill}
						fillOpacity={AudioWaveFillOpacity}
						strokeOpacity={AudioWaveStrokeOpacity}
					/>
				</AreaChart>
			</ResponsiveContainer>
		);
	} catch (e) {
		return <span></span>;
	}
};

export default Amplitude;
